import {ChangeRequest} from 'src/openapi/models/ChangeRequest';

export const sortAttributes = (
    changeRequest: ChangeRequest,
    sourceSpecificAttributesNames: string[],
) => {
    return {
        ...changeRequest,
        event: {
            ...changeRequest.event,
            attributes: changeRequest.event.attributes.toSorted((firstAttribute, secondAttribute) => {
                const isFirstSourceSpecificAttribute = sourceSpecificAttributesNames.includes(firstAttribute.name);
                const isSecondSourceSpecificAttribute = sourceSpecificAttributesNames.includes(secondAttribute.name);

                if (firstAttribute.deprecated !== secondAttribute.deprecated) {
                    return firstAttribute.deprecated ? 1 : -1;
                }

                if (isFirstSourceSpecificAttribute !== isSecondSourceSpecificAttribute) {
                    return isFirstSourceSpecificAttribute ? -1 : 1;
                }

                return firstAttribute.name.localeCompare(secondAttribute.name);
            }),
        },
    };
};
